import request from "@/plugins/axios";


export function upload(appName, version, file) {
    let data = new FormData()
    data.append("appName", appName)
    data.append("version", version)
    data.append("file", file)
    return request.post("/upload", data, {headers: {'Content-Type': 'multipart/form-data'}})
}

export function uploadToken(appName, versionStr, file) {
    let url = "/upload/token?appName=" + appName + "&version=" + versionStr + "&fileName=" + file.name;
    return request.get(url);
}

export function uploadWithToken(res, file) {
    const obj = res.data;
    const options = {};
    options['method'] = 'POST';
    const formData = new FormData();
    formData.append('name', obj.name);
    formData.append('key', obj.key);
    formData.append('policy', obj.policy);
    formData.append('OSSAccessKeyId', obj.accessId);
    formData.append('success_action_status', '200');
    formData.append('callback', obj.callback);
    formData.append('signature', obj.signature);
    formData.append('file', file);
    options['body'] = formData;

    return fetch(res.data.host, options).then(result => {
        return result.json();
    }).then(result => {
        return result;
    }).catch(err => {
        console.log(err);
        return null;
    });
}